import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  firstSubContainer: {
    marginBottom: theme.spacing(1),
  },
  secondSubContainer: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  secondSubContainerTitle: {
    fontSize: "1rem",
    color: "#898989",
  },
  secondSubContainerData: {
    color: theme.palette.secondary.dark,
  },
  summaryContainer: {
    marginBottom: theme.spacing(3),
  },
  suggestedTitle: {
    color: "#898989",
    fontSize: "1.1rem",
  },
  label: {
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.dark,
    marginTop: theme.spacing(1),
  },
  membersTitle: {
    color: "#898989",
    fontSize: "1.1rem",
    marginBottom: theme.spacing(2),
  },
  hideButtonText: {
    color: theme.palette.primary.dark,
  },
  chipRoot: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: "6px",
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  chipLabel: {
    color: theme.palette.primary.dark,
    textTransform: "capitalize",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    fontWeight: 300,
  },
}))

export default styles
